export const sortObj = (array?: any[]) => {
  if (!array) return [];
  const sortArray = [...array];
  const collator = new Intl.Collator('ru');
  return sortArray.sort((a, b) => {
    return collator.compare(a.name, b.name);
  });
};
